// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as DTS_Types from "../DTS.Types/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var readImpl = /* #__PURE__ */ Simple_JSON.readImpl(Simple_JSON.readString);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var VisibilityPhase = function (x) {
    return x;
};
var tsBridgeVisibilityPhase = {
    tsBridge: function (v) {
        return pure(new DTS_Types.TsTypeIntersection([ new DTS_Types.TsTypeUnion([ new DTS_Types.TsTypeTypelevelString("hidden"), new DTS_Types.TsTypeTypelevelString("visible") ]), new DTS_Types.TsTypeRecord([ new DTS_Types.TsRecordField("__brandVisibilityPhase", {
            readonly: true,
            optional: false
        }, new DTS_Types.TsTypeTypelevelString("VisibilityPhase")) ]) ]));
    }
};
var visibilityPhaseVisible = "visible";
var visibilityPhaseToString = function (v) {
    return v;
};
var writeVisibilityPhase = {
    writeImpl: /* #__PURE__ */ (function () {
        var $19 = Simple_JSON.writeImpl(Simple_JSON.writeForeignString);
        return function ($20) {
            return $19(visibilityPhaseToString($20));
        };
    })()
};
var visibilityPhaseHidden = "hidden";
var visibilityPhaseNamespace = {
    hidden: visibilityPhaseHidden,
    visible: visibilityPhaseVisible
};
var visibilityPhaseFromString = function (value) {
    if (value === "hidden") {
        return new Data_Maybe.Just(visibilityPhaseHidden);
    };
    if (value === "visible") {
        return new Data_Maybe.Just(visibilityPhaseVisible);
    };
    return Data_Maybe.Nothing.value;
};
var showVisibilityPhase = Data_Show.showString;
var readVisibilityPhase = {
    readImpl: function (value) {
        return bind(readImpl(value))(function (raw) {
            var v = visibilityPhaseFromString(raw);
            if (v instanceof Data_Maybe.Just) {
                return pure1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid VisibilityPhase: " + raw));
            };
            throw new Error("Failed pattern match at Ouroboros.Models.Ui.VisibilityPhase (line 54, column 5 - line 56, column 82): " + [ v.constructor.name ]);
        });
    }
};
var ordVisibilityPhase = Data_Ord.ordString;
var eqVisibilityPhase = Data_Eq.eqString;
export {
    visibilityPhaseHidden,
    visibilityPhaseVisible,
    visibilityPhaseNamespace,
    visibilityPhaseFromString,
    visibilityPhaseToString,
    eqVisibilityPhase,
    ordVisibilityPhase,
    showVisibilityPhase,
    readVisibilityPhase,
    writeVisibilityPhase,
    tsBridgeVisibilityPhase
};
//# sourceMappingURL=index.js.map
